import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetLocationPermissionRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetLocationPermissionResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getLocationPermission = (request: GetLocationPermissionRequest, options?: CashRequestOptions) =>
  post<GetLocationPermissionRequest, GetLocationPermissionResponse>('/2.0/cash/get-location-permission', request, {
    ...options,
    rejectOnError: true,
  })
